'use strict';

var React = require('react');

var SvgTransportMajor = function SvgTransportMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M1.282 13.469a.506.506 0 0 1-.132-.814l1.093-1.087a1.537 1.537 0 0 1 1.084-.447h2.43l1.963-1.953-6.392-2.826a.507.507 0 0 1-.154-.823l1.972-1.96a1.538 1.538 0 0 1 1.357-.422l7.855 1.42 2.98-2.964a2.174 2.174 0 0 1 3.027.038 2.15 2.15 0 0 1 .038 3.01l-3.013 2.997 1.442 8.607a1.52 1.52 0 0 1-.662 1.518l-1.736 1.151a.512.512 0 0 1-.75-.216l-2.898-6.482-1.964 1.953v2.417c0 .404-.162.791-.45 1.077l-1.092 1.087a.512.512 0 0 1-.818-.132l-1.726-3.433-3.453-1.716z"
  }));
};

exports.SvgTransportMajor = SvgTransportMajor;
